module.exports = __webpack_public_path__ + "/img/800445ca4cf98f6f38f9740b612b36d3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/homeimg/expert-splash-img01.jpg
 ** module id = 13
 ** module chunks = 0 4 5
 **/